<script setup>
import { ref } from "vue";
import { router } from "@inertiajs/vue3";
import ToggleFavorite from "@/Components/Product/ToggleFavorite.vue";
const props = defineProps({
    product: {
        type: Object,
        required: true,
    },
    horizontal: {
        type: Boolean,
        default: false,
    },
});

const show = ref(false);
const showProductDetails = (product) => {
    if (product.url) {
        router.visit(product.url);
    }
};

const placeholderImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
</script>

<template>
    <v-menu v-model="show" :close-on-content-click="true" location="left" open-on-hover>
        <template v-slot:activator="{ props }">
            <Link :href="product?.url || '#'" v-bind="props" class="">
                <div class="product-card rounded-xl border bg-[#F7F7F7] w-full transform transition-all duration-500 
                dark:bg-[#1b1b1b] hover:bg-primary/10 dark:hover:bg-primary/10 hover:scale-105">
                    <!-- Image Section -->
                    <div class="relative">
                        <v-img v-if="product?.thumb_file_id && product?.thumb_file?.type === 'image'"
                            :src="product?.thumb_file?.media_url" :lazy-src="placeholderImage" contain
                            transition="fade-transition" class="object-cover w-full border rounded-t-xl aspect-video h-[250px]">
                            <!-- Loading Screen -->
                            <template v-slot:placeholder>
                                <div class="d-flex align-center justify-center h-full">
                                    <v-progress-circular indeterminate color="grey-lighten-5" />
                                </div>
                            </template>

                            <!-- Error Message -->
                            <template v-slot:error>
                                <div class="d-flex align-center justify-center h-full text-red-500">
                                    <v-icon icon="mdi-alert-circle-outline" class="mr-2" />
                                    <span>فشل تحميل الصورة</span>
                                </div>
                            </template>
                        </v-img>
                        
                        <!-- Location Badge -->
                        <!-- <div class="absolute p-1 bg-white border rounded-md bottom-3 right-3">
                            <div class="flex items-center gap-2">
                                <v-icon class="text-[13px]">mdi-map-marker</v-icon>
                                <div class="text-[13px]">
                                    {{ product?.state?.name }}, {{ product?.city?.name }}, {{ product?.district?.name }}
                                </div>
                            </div>
                        </div> -->
                        
                        <!-- Favorite Button -->
                        <!-- <div class="absolute top-3 right-3">
                            <ToggleFavorite :product="product" />
                        </div> -->
                    </div>
                    
                    <!-- Product Title -->
                    <div class="p-4 text-center">
                        <h3 class="text-lg  text-black dark:text-white truncate">
                            {{ product.title_current_lang }}
                        </h3>
                    </div>
                </div>
            </Link>
        </template>
    </v-menu>
</template>
